import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminSideExpendituresColumns";
import moment from "moment-jalaali";
import DeleteExpenditure from "@general/deleteSideExpenditure";

function SideExpendituresTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate,
}) {
  const [tableData, setTableData] = useState([]);
  const { getExpendituresCount: count, getExpenditures: sideExpenditures } =
    data;

  useEffect(() => {
    const initialTableData = [];
    sideExpenditures.map((sideExpenditure) => {
      const { id, createdAt, updatedAt, amount, description, occurrenceAt } =
        sideExpenditure;
      initialTableData.push({
        key: id,
        updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        occurrenceAt: moment(occurrenceAt).format("jYYYY/jMM/jDD"),
        amount: amount.toLocaleString(),
        description,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
            |
            <DeleteExpenditure id={id} onDeleteExpenditure={onDataUpdate}>
              <a>
                <DeleteOutlined />
              </a>
            </DeleteExpenditure>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [sideExpenditures]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default SideExpendituresTable;
